"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _reactRouterDom = require("react-router-dom");

// Based on https://reactrouter.com/web/guides/scroll-restoration
var ScrollToTop = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _useLocation = (0, _reactRouterDom.useLocation)(),
      pathname = _useLocation.pathname;

  (0, _react.useEffect)(function () {
    if (ref !== null && ref !== void 0 && ref.current) ref.current.scrollTo(0, 0);else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
});
var _default = ScrollToTop;
exports["default"] = _default;